var map = {
	"./CurationListDefaultLayout": [
		"1270",
		"chunk-9580150e"
	],
	"./CurationListDefaultLayout.vue": [
		"1270",
		"chunk-9580150e"
	],
	"./CurationListHistoryLayout": [
		"d1cd",
		"chunk-2d21da64"
	],
	"./CurationListHistoryLayout.vue": [
		"d1cd",
		"chunk-2d21da64"
	],
	"./CurationListReceiveLayout": [
		"533c",
		"chunk-0503436d"
	],
	"./CurationListReceiveLayout.vue": [
		"533c",
		"chunk-0503436d"
	],
	"./CurationListRequestLayout": [
		"1820",
		"chunk-304c441c"
	],
	"./CurationListRequestLayout.vue": [
		"1820",
		"chunk-304c441c"
	],
	"./CurationListSendLayout": [
		"4fea",
		"chunk-f93c5cf6"
	],
	"./CurationListSendLayout.vue": [
		"4fea",
		"chunk-f93c5cf6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6ea2";
module.exports = webpackAsyncContext;